import { FC, useState } from 'react';
import { useTrans } from 'base/utils/i18n';
import { OptionBtn } from '@pro/420CheckIn/Interactive/OptionBtn';
import { ICheckInData } from 'mod/checkIn/interface';
import { ICheckInInstance } from 'mod/checkIn/useCheckIn';
import styles from './index.module.less';
import site from 'pro/config/site';
import { Button } from '@base/lib/Button';
import { SharePopupM } from '@base/lib/share/SharePopupM';
import { useRouter } from 'next/router';
import Iconfont from '@base/lib/Iconfont';
import { SharePopup } from '@base/lib/share/SharePopup';
import { SharePopupPC } from '@base/lib/share/SharePopupPC';

type IProps = {
    data: ICheckInData;
    fetchData: ICheckInInstance['fetchData'];
    shareCallback: ICheckInInstance['shareCallback'];
};

export const OptionShare: FC<IProps> = props => {
    const { data: { shareBoom }, shareCallback } = props;
    const { t } = useTrans();
    const router = useRouter();

    return (
        <>
            <SharePopup
                url={router.pathname}
                onClickItem={() => shareCallback(true)}
                needLogin={false}
                trigger={
                    <OptionBtn>
                        <strong>{t('web_common_btn_share_now_upper')}</strong>
                        <span>{t('web_checkin_make_rate_boom', { rate: shareBoom.boomRate })}</span>
                    </OptionBtn>
                }
                m={{
                    title: site.brand
                }}
            />
        </>
    )
};
